import React from 'react';
import './Header.css'

const Header = () => {
  return <div className='header'>
    <div className="title">
      Caesar Cipher
    </div>
  </div>
};


export default Header


// WEBPACK FOOTER //
// ./src/components/Header/Header.js